export const MIN_PRICE_INPUT_NAME = 'minPrice'
export const MAX_PRICE_INPUT_NAME = 'maxPrice'
export const MAX_PRICE_ERROR_MSG = 'Maximum price should not be less than minimal price'
export const MIN_PRICE_ERROR_MSG = 'Minimal price should more than 0'
